import { Box, Chip, Typography } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { Offer } from '../../services/offers.service';
import ActivityCell from '../../components/ActivityCell';
import TagChips from '../../components/TagChips';

export function offersColumns(opts: { includeNetwork?: boolean; actions: GridColDef<Offer> }): GridColDef<Offer>[] {
  return [
    { field: 'ref', headerName: 'Ref', width: 90, sortable: false, valueGetter: (_v, row) => row.ref || '—' },
    { field: 'name', headerName: 'Offer Name', flex: 1, minWidth: 180 },
    { field: 'url', headerName: 'URL', flex: 1, minWidth: 180, renderCell: (p: GridRenderCellParams) => (
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}><Typography variant="body2" noWrap title={p.value}>{p.value}</Typography></Box>
    )},
    ...(opts.includeNetwork
      ? [{ field: 'network', headerName: 'Network', width: 140, valueGetter: (_v, row) => row.network?.name || '-' } as GridColDef<Offer>]
      : []),
    { field: 'currency', headerName: 'Currency', width: 80, valueFormatter: (v) => v || 'USD' },
    {
      field: '_activity', headerName: 'Activity', width: 180, filterable: false,
      description: 'Non-bot visits in the last hour and the last 24 hours. Sorts by the last 24 hours.',
      renderCell: (p: GridRenderCellParams) => (
        <ActivityCell
          activity={p.row.activity_status} senderLabel="Flows sending to it"
          parts={['expected', 'h24', 'h1']} kind="offer" entityId={p.row.id}
          updatedAt={p.row.activity_updated_at}
        />
      ),
    },
    { field: 'traffic_cap_limit', headerName: 'Cap', width: 70, type: 'number', editable: true, valueFormatter: (v) => Number(v) > 0 ? String(v) : '-' },
    { field: 'postback', headerName: 'Postback', width: 130, valueGetter: (_v, row) => row.postback?.name || '-' },
    { field: 'status', headerName: 'Status', width: 90, renderCell: (p: GridRenderCellParams) => (
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}><Chip label={p.value} size="small" color={p.value === 'active' ? 'success' : p.value === 'archived' ? 'warning' : 'default'} /></Box>
    )},
    { field: 'tag_ids', headerName: 'Tags', flex: 1, minWidth: 150, sortable: false, renderCell: (p: GridRenderCellParams) => <TagChips ids={p.value ?? []} /> },
    { field: 'created_at', headerName: 'Created', width: 100, valueFormatter: (v) => new Date(v).toLocaleDateString() },
    opts.actions,
  ];
}
